import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <UpdatesSection />
        <AboutSection />
        <RankingSection />
        <CarouselSection />
        <AppSection />
        <CommentsSection />
        <TopicsSection />
        <IndexSection />
        <FeaturesSection />
        <FaqSection />
        <CardsSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}